var scope_0 = require('/Users/kervanaslan/Desktop/projects/popupfox-web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/15da9dfb0e0e1fb7f67118ae468af7c8.js').default;
var scope_1 = require('/Users/kervanaslan/Desktop/projects/popupfox-web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6c341e3cea5c49887b017531322af9d8.js').default;
var scope_2 = require('/Users/kervanaslan/Desktop/projects/popupfox-web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    